<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="spreadsheetExportNotificationCard"
  [notificationIcon]="'svg_pdf_list'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadSpreadsheetButtonClickedEvent)="downloadSpreadsheetButtonClickedHandler()"
      (openPdfButtonClickedEvent)="openSpreadsheetButtonClickedHandler()"
      [downloadSpreadsheetFlag]="true"
      [downloadSpreadsheetLabel]="spreadsheetExportNotificationCard.multipleFilesFlag ? 'Télécharger le fichier Zip' : 'Télécharger le PDF'"
      [openPdfFlag]="!spreadsheetExportNotificationCard.multipleFilesFlag"
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
